import {
    SHOW_SECTION_INCOMPLETE,
    DISMISS_SECTION_INCOMPLETE
} from '../constants';


export function showSectionIncomplete(obj) {
    return {
        type: SHOW_SECTION_INCOMPLETE,
        payload: obj
    }
}

export function resetSectionIncomplete() {
    return {
        type: DISMISS_SECTION_INCOMPLETE,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/section.js